"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.hbvTreatedEverMessages = exports.hbvCurrentStateMessages = exports.HbvTreatedEver = exports.HbvCurrentState = void 0;
const schema_1 = require("../../../../../schema");
var HbvCurrentState;
(function (HbvCurrentState) {
    HbvCurrentState["PCR_NEGATIVE"] = "PCR_negative";
    HbvCurrentState["PCR_POSITIVE"] = "PCR_positive";
    HbvCurrentState["UNKNOWN"] = "UNKNOWN";
})(HbvCurrentState || (exports.HbvCurrentState = HbvCurrentState = {}));
var HbvTreatedEver;
(function (HbvTreatedEver) {
    HbvTreatedEver["YES"] = "YES";
    HbvTreatedEver["NO"] = "NO";
    HbvTreatedEver["UNKNOWN"] = "UNKNOWN";
})(HbvTreatedEver || (exports.HbvTreatedEver = HbvTreatedEver = {}));
exports.hbvCurrentStateMessages = {
    [HbvCurrentState.PCR_NEGATIVE]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHbv.hbvCurrentState.PCR_NEGATIVE",
        defaultMessage: "PCR Negatív"
    },
    [HbvCurrentState.PCR_POSITIVE]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHbv.hbvCurrentState.PCR_POSITIVE",
        defaultMessage: "PCR Pozitív"
    },
    [HbvCurrentState.UNKNOWN]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHbv.hbvCurrentState.UNKNOWN",
        defaultMessage: "Ismeretlen"
    }
};
exports.hbvTreatedEverMessages = {
    [HbvTreatedEver.YES]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHbv.hbvTreatedEver.YES",
        defaultMessage: "Igen"
    },
    [HbvTreatedEver.NO]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHbv.hbvTreatedEver.NO",
        defaultMessage: "Nem"
    },
    [HbvTreatedEver.UNKNOWN]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHbv.hbvTreatedEver.UNKNOWN",
        defaultMessage: "Ismeretlen"
    }
};
const hbvCurrentState = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HbvCurrentState.PCR_NEGATIVE).interpretation({
        vocab: "ktx",
        code: "HBV_status_PCR_negative"
    }),
    schema_1.Schema.singleChoiceItem(HbvCurrentState.PCR_POSITIVE).interpretation({
        vocab: "ktx",
        code: "HBV_status_PCR_positive"
    }),
    schema_1.Schema.singleChoiceItem(HbvCurrentState.UNKNOWN).interpretation({
        vocab: "ktx",
        code: "HBV_status_unknown"
    })
]);
const hbvTreatedEver = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HbvTreatedEver.YES),
    schema_1.Schema.singleChoiceItem(HbvTreatedEver.NO),
    schema_1.Schema.singleChoiceItem(HbvTreatedEver.UNKNOWN)
]);
const hbvTreatedComment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hbvCurrentState, hbvTreatedEver, hbvTreatedComment })
    .interpretation({
    vocab: "ktx",
    code: "hbv_chronic_liver_failure_statement"
})
    .tag({ vocab: "fyrms", code: "action" });
